<template>
  <div id="about" class="my-5 scrollElement">
    <div class="row d-grid">
      <div class="col-10 row align-self-center mx-auto">
        <div class="col-lg-5">
          <img src="/img/cup.png" class="img-fluid mt-2" alt="">
        </div>
        <div class="col-lg-7 d-grid">
          <div class="align-self-end">
            <h3 class="text-center my-5">درباره کوپاکافه</h3>
            <p class="text-justify px-lg-5">
              کوپاکافه برند اختصاصی شرکت آماده لذیذ در تولید قهوه است که با ارائه انواع قهوه سعی دارد نیاز مخاطبین خود را به بهترین نحو برآورده کند.
              ما در کوپاکافه بر آن شدیم تا بتوانیم قهوه ای با کیفیت در اختیار مشتریان عزیزمان قرار دهیم.
              با بیش از 20 سال سابقه تولید و دانش ساخت بر آنیم تا تجربه ای بیاد ماندنی در ذهن مخاطب خود داشته باشیم و با بکارگیری نیروی متخصص بهمراه به‌روزترین و کارآمدترین تکنولوژی و دانش روز دنیا محصولی باکیفیت و متناسب با استانداردهای جهانی در ایران تولید کنیم.
              آشنایی با سلیقه ایرانیان در قهوه و تجربه بیش از 15 سال حضور در این بازار به ما این امکان را میدهد تا بتوانیم در کنار انواع قهوه های فوری و میکس به تولید قهوه های دمی نیز بپردازیم تا در جبران کمبود تنوع این محصول در بازار کمک کنیم.
            </p>
          </div>
        </div>

      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "About"
}
</script>

<style scoped>

</style>